import { create } from "zustand";
import axiosInstance from "../utils/axiosInstance";

export const useCurrenciesStore = create((set, get) => ({
    currencies: [],
    addCurrency: (newCurrency) => set({currencies: [...this.currencies, newCurrency]}),
    updateCurrencies: (newCurrencies) => set({currencies: newCurrencies}),
    loading: false,
    error: null,
    fetchCurrencies: async () => {
        set({ loading: true, error: null })
        try {
            const response = await axiosInstance.get('/api/currencies/list')
            console.log('Currencies API response:', response.data)
            
            // Extract the data and current_currency from the response
            const { data: currencies, current_currency } = response.data
            
            // Update both currencies list and selected currency
            set({ 
                currencies: currencies, 
                selectedCurrency: current_currency, 
                loading: false 
            })
        } catch (error) {
            console.error('Error fetching currencies:', error)
            set({ error: error.message, loading: false })
        }
    },
    selectedCurrency: null,
    setSelectedCurrency: async (currency) => {
        set({ loading: true, error: null })
        try {
            // First update local state
            set({ selectedCurrency: currency })
            
            // Then update the system currency on the backend
            await get().updateSystemCurrency(currency)
            
            // Finally refresh all currency-dependent data
            await get().refreshData()
            
            set({ loading: false })
        } catch (error) {
            console.error('Error updating currency:', error)
            set({ error: error.message, loading: false })
        }
    },
    updateSystemCurrency: async (currency) => {
        try {
            // Make an API call to update the system currency
            await axiosInstance.post('/api/currencies/change-currency', { currency_short_name: currency })
            return true
        } catch (error) {
            // Check if the error is due to endpoint not found (404) 
            // or server error (500)
            if (error.response && (error.response.status === 404 || error.response.status === 500)) {
                console.warn('Currency update endpoint not available. Continuing with local currency change only.');
                // Continue with local currency change only
                return true;
            }
            
            console.error('Error updating system currency:', error)
            throw error
        }
    },
    refreshData: async () => {
        try {
            // Create an array of promises for all data that needs refreshing
            
            // Reload the entire page to ensure all UI reflects the updated currency
            window.location.reload();
            
            return true;
        } catch (error) {
            console.error('Error in refreshData:', error);
            // Even if refresh fails, we'll consider the currency change successful
            // since the local state is updated
            return true;
        }
    }
}))

export const useMoney = () => {
    const {currencies, selectedCurrency} = useCurrenciesStore.getState()

    const money = (value, withCents = true) => {
        let val = value
        if(withCents) {
            val = (value / 100.00).toFixed(2)
        }
        let money = val
        if (selectedCurrency && currencies.length > 0) {
            const currency = currencies.find(c => c.short_name === selectedCurrency)
            if (currency) {
                if(currency.position == 'back') {
                    money = val+currency.symbol
                } else {
                    money = currency.symbol+val
                }
            }
        }
        return money
    }

    return {money}
}
